<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-card style="border: none; margin-left: 2rem; margin-right: 2rem; margin-top: 2rem; margin-bottom: 0">
      <div  v-if="isAGeber">
        <b-row class="justify-content-md-center">
          <b-col lg="6" md="6" sm="10" style="    padding: 20px;
    background: #FBFBFB;
    border-radius: 20px;
    border: 1px solid #F0F0F0;">
            <b-row>
              <b-col md="6">
                <h5>Auftraggeber</h5>
              </b-col>
              <b-col md="6">
                <b-button style="float: right;" variant="primary" size="sm" @click="toggleButton">
                  abw. Rechn.-Empfänger
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <label for="anrede">Anrede</label>
                <b-form-select :options="anrede_select" id="anrede" :plain="true"
                               v-model="gi_anrede"
                               class="mb-2 text-black"></b-form-select>
              </b-col>
            </b-row>
                <label for="name">Name 1</label>
                <b-form-input id="name" type="text"
                              v-model="gi_name1"
                              class="mb-2"
                              maxlength="30"
                ></b-form-input>
            <b-form-text style="text-align: right">{{gi_name1.length}}/30</b-form-text>
            <label for="name">Name 2</label>
            <b-form-input id="name" type="text"
                          v-model="gi_name2"
                          class="mb-2"
                          maxlength="30"
            ></b-form-input>
            <b-form-text style="text-align: right">{{gi_name2.length}}/30</b-form-text>
            <label for="name" v-if="show_email">Email</label>
            <b-form-input id="name" type="text"
                          v-model="gi_email"
                          class="mb-3"
                          v-if="show_email"
            ></b-form-input>
            <label for="str_hnr">Straße Hausnummer</label>
            <b-form-input id="str_hnr" type="text"
                          v-model="gi_strasse"
                          class="mb-2"
                          maxlength="30"
            ></b-form-input>
            <b-form-text style="text-align: right">{{gi_strasse.length}}/30</b-form-text>
            <b-row>
              <b-col sm="4">
                <label for="plz">PLZ</label>
                <b-form-input id="plz" type="text"
                              v-model="gi_plz"
                              class="mb-2"
                              maxlength="5"
                ></b-form-input>
                <b-form-text style="text-align: right">{{gi_plz.length}}/5</b-form-text>
              </b-col>
              <b-col sm="8">
                <label for="ort">Ort</label>
                <b-form-input id="ort" type="text"
                              v-model="gi_ort"
                              class="mb-2"
                              maxlength="30"
                ></b-form-input>
                <b-form-text style="text-align: right">{{gi_ort.length}}/30</b-form-text>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div  v-else>
        <b-row class="justify-content-md-center">
          <b-col lg="6" md="6" sm="10" style="    padding: 40px;
    background: #FBFBFB;
    border-radius: 20px;
    border: 1px solid #F0F0F0;">
            <b-row>
              <b-col md="6">
                <h5>Abweichender Rechnungsempfänger</h5>
              </b-col>
              <b-col md="6">
                <b-button style="float: right;" variant="primary" size="sm" @click="toggleButton">
                  Auftraggeber
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <label for="anrede">Anrede</label>
                <b-form-select :options="anrede_select" id="anrede" :plain="true"
                               v-model="re_anrede"
                               class="mb-2 text-black"></b-form-select>
              </b-col>
              <b-col sm="8">
                <label for="pk_nr">PK-Nr.</label>
                <b-form-input id="pk_nr" type="text"
                              v-model="renr"
                              class="mb-2"
                              maxlength="20"
                ></b-form-input>
                <b-form-text style="text-align: right">{{renr.length}}/20</b-form-text>
              </b-col>
            </b-row>
            <label for="name">Name</label>
            <b-form-input id="name" type="text"
                          v-model="re_vorname"
                          class="mb-2"
                          maxlength="60"
            ></b-form-input>
            <b-form-text style="text-align: right">{{re_vorname.length}}/60</b-form-text>

            <label for="name">zu Händen von</label>
            <b-form-input id="name" type="text"
                          v-model="re_name1"
                          class="mb-2"
                          maxlength="60"
            ></b-form-input>
            <b-form-text style="text-align: right">{{re_name1.length}}/60</b-form-text>
            <label for="str_hnr">Straße Hausnummer</label>
            <b-form-input id="str_hnr" type="text"
                          v-model="re_str_hnr"
                          class="mb-2"
                          maxlength="60"
            ></b-form-input>
            <b-form-text style="text-align: right">{{re_str_hnr.length}}/60</b-form-text>
            <b-row>
              <b-col sm="2">
                <label for="land">Ländercode</label>
                <b-form-input id="land" type="text"
                              v-model="re_land"
                              class="mb-2"
                              placeholder="z.B. DE"
                              maxlength="3"
                ></b-form-input>
                <b-form-text style="text-align: right">{{re_land.length}}/3</b-form-text>
              </b-col>
              <b-col sm="2">
                <label for="plz">PLZ</label>
                <b-form-input id="plz" type="text"
                              v-model="re_plz"
                              class="mb-2"
                              maxlength="5"
                ></b-form-input>
                <b-form-text style="text-align: right">{{re_plz.length}}/5</b-form-text>
              </b-col>
              <b-col sm="8">
                <label for="ort">Ort</label>
                <b-form-input id="ort" type="text"
                              v-model="re_ort"
                              class="mb-2"
                              maxlength="80"
                ></b-form-input>
                <b-form-text style="text-align: right">{{re_ort.length}}/80</b-form-text>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
import {decryptAES} from "@/shared/crypto";

export default {
  name: "task_setp_ageber",
  props: ['currentStep'],
  mounted() {
    this.aufisn = this.currentStep.payload.selected_aufisn.gi_aufisn;
    this.a_geber = this.currentStep.payload.selected_group.id;
    this.$emit('can-continue', {value: true});
    this.showLoader();
    this.$http.get(
        Server_URL+'/auftragsbuch/data/create/step_ageber?aufisn='+this.aufisn+"&a_geber="+this.a_geber
    ).then(this.responseOkGet, this.responseError)
  },
  data() {
    return {
      loader: undefined,
      isAGeber: true,
      anrede_select: ["Firma", "An den", "An die", "An das", "Herr", "Frau"],

      aufisn: '',
      a_geber: '',
      gi_anrede: '',
      gi_name1: '',
      gi_name2: '',
      gi_strasse: '',
      gi_plz: '',
      gi_ort: '',
      gi_email: '',
      show_email: false,

      re_anrede: '',
      renr: '',
      re_vorname: '',
      re_name1: '',
      re_str_hnr: '',
      re_land: '',
      re_plz: '',
      re_ort: '',

    }
  },
  methods: {
    toggleButton() {
      this.isAGeber = !this.isAGeber;
    },
    setActive: function (payload) {
      if (this.aufisn !== this.currentStep.payload.selected_aufisn.gi_aufisn
          || this.a_geber !== this.currentStep.payload.selected_group.id) {
        this.aufisn = this.currentStep.payload.selected_aufisn.gi_aufisn;
        this.a_geber = this.currentStep.payload.selected_group.id;
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/create/step_ageber?aufisn='+this.aufisn+"&a_geber="+this.a_geber
        ).then(this.responseOkGet, this.responseError)
      }
      this.$emit('can-continue', {value: true});
    },
    getReturnData: function () {
      return {
        aGeber: {
          gi_anrede: this.gi_anrede,
          gi_name1: this.gi_name1,
          gi_name2: this.gi_name2,
          gi_strasse: this.gi_strasse,
          gi_plz: this.gi_plz,
          gi_ort: this.gi_ort,
          gi_email: this.show_email ? this.gi_email : '',
        },
        re: {
          re_anrede: this.re_anrede,
          renr: this.renr,
          re_vorname: this.re_vorname,
          re_name1: this.re_name1,
          re_str_hnr: this.re_str_hnr,
          re_land: this.re_land,
          re_plz: this.re_plz,
          re_ort: this.re_ort,
        }
      };
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    async responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200 && response.body.status === "ok") {
        let resp = response.body.data;
        console.log(response.body)
        try {
          this.gi_anrede =  await decryptAES(sessionStorage.getItem("aes"), resp.gi_anrede)
        } catch (e) {
          this.gi_anrede =  resp.gi_anrede
        }
        try {
          this.gi_name1 =  await decryptAES(sessionStorage.getItem("aes"), resp.gi_name1)
        } catch (e) {
          this.gi_name1 =  resp.gi_name1
        }
        try {
          this.gi_name2 =  await decryptAES(sessionStorage.getItem("aes"), resp.gi_name2)
        } catch (e) {
          this.gi_name2 =  resp.gi_name2
        }
        if (this.gi_name2 === '' && resp.department_name !== '') {
          this.gi_name2 = resp.department_name;
        }
        try {
          this.gi_strasse =  await decryptAES(sessionStorage.getItem("aes"), resp.gi_strasse)
        } catch (e) {
          this.gi_strasse =  resp.gi_strasse
        }
        try {
          this.gi_strasse += " " + await decryptAES(sessionStorage.getItem("aes"), resp.gi_hnr)
        } catch (e) {
          this.gi_strasse += " " + resp.gi_hnr
        }
        try {
          this.gi_strasse += " " + await decryptAES(sessionStorage.getItem("aes"), resp.gi_additive)
        } catch (e) {
          this.gi_strasse += " " + resp.gi_additive
        }

        if (this.gi_strasse === '' && resp.department_strasse !== '') {
          this.gi_strasse = resp.department_strasse + " " + resp.department_hnr + " " + resp.department_additive;
        }

        try {
          this.gi_plz =  await decryptAES(sessionStorage.getItem("aes"), resp.gi_plz)
        } catch (e) {
          this.gi_plz =  resp.gi_plz
        }

        if (this.gi_plz === '' && resp.department_plz !== '') {
          this.gi_plz = resp.department_plz;
        }

        try {
          this.gi_ort =  await decryptAES(sessionStorage.getItem("aes"), resp.gi_ort)
        } catch (e) {
          this.gi_ort = resp.gi_ort
        }
        if (this.gi_ort === '' && resp.department_ort !== '') {
          this.gi_ort = resp.department_ort;
        }
        this.show_email = resp.show_email;
        try {
          this.gi_email =  await decryptAES(sessionStorage.getItem("aes"), resp.gi_email)
        } catch (e) {
          this.gi_email =  resp.gi_email
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
  }
}
</script>

<style scoped>
.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>
